import { gql } from "@apollo/client";

export const CREATE_THEME = gql`
  mutation CreateThemeMutation($input: CreateThemeInput!) {
    createTheme(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_THEME = gql`
  mutation UpdateThemeMutation($id: Int!, $input: UpdateThemeInput!) {
    updateTheme(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_THEME = gql`
  mutation RemoveThemeMutation($id: Int!) {
    removeTheme(id: $id) {
      ok
      error
    }
  }
`;

export const THEME = gql`
  query ThemeQuery($id: Int!) {
    theme(id: $id) {
      ok
      error
      result {
        id
        code
        name
        promptText
      }
    }
  }
`;

export const THEMES = gql`
  query ThemesQuery {
    themes {
      ok
      error
      total
      results {
        id
        code
        name
        promptText
      }
    }
  }
`;
